const _ = require('lib/underscore')
const ChecklistItem = require('./checklist_item')

// special item that is returned as 'next' when they have no incomplete items
const completed_item = {
    id: 'completed',
}

class Checklist {

    constructor(options) {
        this.user = options.user
        this.items = options.items.map(item => {
            const item_options = _.extend({
                user: this.user,
            }, item)
            return new ChecklistItem(item_options)
        })
    }

    all() {
        return Promise.all(this.items.map(item => item.getState()))
    }

    applicable() {
        return new Promise(resolve => {
            this.all()
            .then(all => {
                const applicable = all.filter(item => item.applicable)
                resolve(applicable)
            })
        })
    }

    completed() {
        return new Promise(resolve => {
            this.applicable()
            .then(applicable => {
                const completed = applicable.filter(item => item.completed)
                resolve(completed)
            })
        })
    }

    incomplete() {
        return new Promise(resolve => {
            this.applicable()
            .then(applicable => {
                const incomplete = applicable.filter(item => ! item.completed)
                resolve(incomplete)
            })
        })
    }

    next() {
        return new Promise(resolve => {
            this.incomplete()
            .then(incomplete => resolve(incomplete[0] || completed_item))
        })
    }

}

module.exports = Checklist
